import { serverBaseUrl } from "../config/envs";
import { MAX_BATCH } from "../pages/signAllBatch";

export const CP_BATCH_MAX = MAX_BATCH;
export const CP_BATCH_UNAVAILABLE = "These documents are not available right now. Please try again later.";
const legacySecret = /^\d+-\d+-[0-9a-f]+$/;
const documentSecret = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const positiveId = (value) => Number.isSafeInteger(value) && value > 0 && value <= 2147483647;

export function parseCpSigningBatchHash(hash) {
  const text = String(hash ?? "").replace(/^#/, "");
  if (!text) return [];
  const parts = text.split(",");
  if (parts.length > CP_BATCH_MAX || parts.some((part) => part.length > 255 || !(legacySecret.test(part) || documentSecret.test(part)))) return null;
  return [...new Set(parts)];
}

export async function attestCpSigningBatch(secrets) {
  if (!Array.isArray(secrets) || !secrets.length || secrets.length > CP_BATCH_MAX || new Set(secrets).size !== secrets.length
    || secrets.some((secret) => typeof secret !== "string" || secret.length > 255 || !(legacySecret.test(secret) || documentSecret.test(secret)))) {
    throw new Error("Open Documents and select the documents to sign again.");
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 30000);
  let response, body;
  try {
    response = await fetch(`${serverBaseUrl}/cp_document_sign_links/attest`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sign_secret_ids: secrets }), credentials: "omit", cache: "no-store", referrerPolicy: "no-referrer", signal: controller.signal,
    });
    try { body = await response.json(); } catch { /* A proxy can return an HTML failure. */ }
  } catch {
    throw new Error("Could not load this signing session. Check your connection and try again.");
  } finally { clearTimeout(timer); }
  const data = body?.data;
  const types = data?.role_key === "physician" ? [6, 10] : data?.role_key === "operator" ? [7, 11] : [];
  const valid = positiveId(data?.actor_id) && types.length && Array.isArray(data.links) && data.links.length === secrets.length
    && data.links.every((link, index) => link && link.index === index && types.includes(link.document_type)
      && link.actor_id === data.actor_id && link.role_key === data.role_key && [0, 1, 2].includes(link.status)
      && [null, "platform", "external", "imported"].includes(link.signature_source));
  if (response.ok && body?.success === true && valid) return data;
  if (response.status === 404 && body?.messageCode === 1156) throw Object.assign(new Error(CP_BATCH_UNAVAILABLE), { code: 1156 });
  throw new Error([400, 403, 404].includes(response.status)
    ? "These documents cannot be signed together. Open Documents and try again with your own signing links."
    : response.ok ? "This signing session returned an unexpected response. Open Documents and try again."
      : "Could not load this signing session. Please try again.");
}
